import { capitalize } from 'lodash';

export default {
  name: 'capitalize',
  fn(value) {
    return capitalize(value);
  },
};
